import { api } from "./dataService";

export const fetchImportJobs = async () => {
  return (await api.get("data/import-jobs")).data;
};

export const fetchImportJob = async (job_id) => {
  return (await api.get(`data/import-jobs/${job_id}`)).data;
};

export const fetchImportJobChanges = async (
  job_id,
  { record_type, actions, page = 1, per_page = 200 } = {}
) => {
  const params = { page, per_page };
  if (record_type) {
    params.record_type = record_type;
  }
  if (actions?.length) {
    params.actions = actions;
  }
  return (await api.get(`data/import-jobs/${job_id}/changes`, { params })).data;
};
